import { ROUNDUP, XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { draftel_codecs_pack_terkk$_bundle_postolje } from './ter-draftel-codec-lib-terkk-bundle-postolje';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';


/*
TODO

Za testiranje da bi se dobio maksiamalni broj ojacanja treba uneti

*/


//
export const _derivat_postolje_izracunaj_sirinapostolja_duzinapostolja = (msirinaspoljasnja, duzinamodula, vrstaprofila) => {
  let sirinapostolja = 0;
  let duzinapostolja = 0;
  if (msirinaspoljasnja > 0) {
    sirinapostolja = msirinaspoljasnja;
  }
  if (duzinamodula > 0) {
    duzinapostolja = duzinamodula;
  }
  if (vrstaprofila === "TB-BELA-70") {
    sirinapostolja -= (30 * 2);
    duzinapostolja -= (30 * 2);
  }
  return {
    sirinapostolja,
    duzinapostolja
  };
};


//
export const _derivat_terkk_postolje_izracunaj_za_subform_arr = (smerojacanjapostolja, sirinapostolja,
  duzinapostolja, sirinaprofilapostolja) => {
  console.log(smerojacanjapostolja, sirinaprofilapostolja);
  let profili_postolja_arr = [];
  //
  if (smerojacanjapostolja === 'PODUZINI') {
    // tip postolja PODUZINI
    console.log('--- PODUZINI');
    const dimenzijazapozicije = sirinapostolja;
    const duzina_za_front_i_back = duzinapostolja;
    const duzina_za_left_i_right = sirinapostolja - (sirinaprofilapostolja * 2);
    const duzina_ojacanja = duzinapostolja - (sirinaprofilapostolja * 2);
    let dvodelni_front_i_back = false;
    if (duzina_za_front_i_back >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_front_i_back = true;
    }
    let dvodelni_laft_i_right = false;
    if (duzina_za_left_i_right >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_laft_i_right = true;
    }
    let dvodelni_reinforcement = false;
    if (duzina_ojacanja >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_reinforcement = true;
    }

    // OKOLNI
    if (dvodelni_front_i_back === false) {
      // JEDNODELNI FRONT I BACK
      profili_postolja_arr.push({
        tempkey: 110,
        tip: 'FRONT',
        duzina: duzina_za_front_i_back,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 120,
        tip: 'BACK',
        duzina: duzina_za_front_i_back,
        kolicina: 1,
        smerojacanjapostolja,
      });
    } else {
      // PODELJENI FRONT I BACK
      profili_postolja_arr.push({
        tempkey: 111,
        tip: 'FRONT_1',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 112,
        tip: 'FRONT_2',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 121,
        tip: 'BACK_1',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 122,
        tip: 'BACK_2',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
    }
    if (dvodelni_laft_i_right === false) {
      // JEDNODELNI LEFT I RIGHT
      profili_postolja_arr.push({
        tempkey: 210,
        tip: 'LEFT',
        duzina: duzina_za_left_i_right,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 220,
        tip: 'RIGHT',
        duzina: duzina_za_left_i_right,
        kolicina: 1,
        smerojacanjapostolja,
      });
    } else {
      // PODELJENI LEFT I RIGHT
      profili_postolja_arr.push({
        tempkey: 211,
        tip: 'LEFT_1',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 212,
        tip: 'LEFT_2',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 221,
        tip: 'RIGHT_1',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 222,
        tip: 'RIGHT_2',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
    }

    // OJACANJA

    const _izracunaj_poziciju_ojacanja = (dimenzijazapozicije, n, total) => {
      if ((n === 1 && total === 1) || (n === 2 && total === 3)) {
        // centralni ili jedini REINFORCEMENT, 1/1 ili 2/3
        const pozicijaojacanja = dimenzijazapozicije / 2;
        return pozicijaojacanja;
      } else if ((total > 1 && n === 1)) {
        // prvi kad je vise od 1 REINFORCEMENT, 1/2 ili 1/3 ili 1/4
        const pozicijaojacanja = 300;
        return pozicijaojacanja;
      } else if (total > 1 && (n === total)) {
        // poslednji kad je vise od 1 REINFORCEMENT, 2/2 ili 3/3 ili 4/4 
        const pozicijaojacanja = dimenzijazapozicije - 300;
        return pozicijaojacanja;
      } else if ((n === 2 && total === 4)) {
        // 2/4 REINFORCEMENT
        const pozicijaojacanja = (dimenzijazapozicije / 2) - 300;
        return pozicijaojacanja;
      } else if ((n === 3 && total === 4)) {
        // 3/4  REINFORCEMENT
        const pozicijaojacanja = (dimenzijazapozicije / 2) + 300;
        return pozicijaojacanja;
      }
    };

    console.log('--- duzinapostolja', duzinapostolja);
    if (sirinapostolja <= 1025) {
      // no renforcement
    } else if (sirinapostolja > 1025 && sirinapostolja <= 1330) {
      // 1 REINFORCEMENT
      if (dvodelni_reinforcement === false) {
        profili_postolja_arr.push({
          tempkey: 310,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 1),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      } else {
        // 1 REINFORCEMENT deljeni
        profili_postolja_arr.push({
          tempkey: 311,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 1),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 312,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 1),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      }

    } else if (sirinapostolja > 1330 && sirinapostolja <= 1940) {
      // 2 REINFORCEMENT
      if (dvodelni_reinforcement === false) {
        profili_postolja_arr.push({
          tempkey: 310,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 320,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      } else {
        // 2 REINFORCEMENT deljeni
        profili_postolja_arr.push({
          tempkey: 311,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 312,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 321,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 322,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 2),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      }
    } else if (sirinapostolja > 1940 && sirinapostolja <= 2245) {
      // 3 REINFORCEMENT
      if (dvodelni_reinforcement === false) {
        profili_postolja_arr.push({
          tempkey: 310,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: 300,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 320,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 330,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      } else {
        // 3 REINFORCEMENT deljeni
        profili_postolja_arr.push({
          tempkey: 311,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 312,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 321,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 322,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 331,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 332,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 3),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      }
    } else if (sirinapostolja > 2245) {
      // 4 REINFORCEMENT
      if (dvodelni_reinforcement === false) {
        profili_postolja_arr.push({
          tempkey: 310,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 320,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 330,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 340,
          tip: 'REINFORCEMENT',
          duzina: duzina_ojacanja,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 4, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      } else {
        // 4 REINFORCEMENT deljeni
        profili_postolja_arr.push({
          tempkey: 311,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 312,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 1, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 321,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 322,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 2, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 331,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 332,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 3, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });

        profili_postolja_arr.push({
          tempkey: 341,
          tip: 'REINFORCEMENT_1',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 4, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
        profili_postolja_arr.push({
          tempkey: 342,
          tip: 'REINFORCEMENT_2',
          duzina: duzina_ojacanja / 2,
          pozicijaprofila: _izracunaj_poziciju_ojacanja(dimenzijazapozicije, 4, 4),
          dimenzijazapozicije: dimenzijazapozicije,
          kolicina: 1,
          smerojacanjapostolja,
        });
      }
    }



  } else if (smerojacanjapostolja === 'POSIRINI') {
    // tip postolja POSIRINI
    console.log('--- POSIRINI');
    profili_postolja_arr = [];
    const dimenzijazapozicije = duzinapostolja;
    const duzina_za_front_i_back = duzinapostolja;
    const duzina_za_left_i_right = sirinapostolja - (sirinaprofilapostolja * 2);
    const duzina_ojacanja = duzina_za_left_i_right;
    let dvodelni_front_i_back = false;
    if (duzina_za_front_i_back >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_front_i_back = true;
    }
    let dvodelni_laft_i_right = false;
    if (duzina_za_left_i_right >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_laft_i_right = true;
    }
    let dvodelni_reinforcement = false;
    if (duzina_ojacanja >= 2851) {
      // ako je duzina (umanjena za 110) veca ili jednako od 2851 onda je iz dva dela
      dvodelni_reinforcement = true;
    }
    /*
    - Samo kad je postolje sa smerojacanja POSIRINI moze da ima kadicu i tada moze da ima rupe za odvod kondenzacije.
    - Takodje kad je smerojacanja POSIRINI onda se FRONT nikada ne deli?? PROVERITI???
    */
    const _odvod123 = {
      pozicijaodvodakondenzata1: 0,
      pozicijaodvodakondenzata2: 0,
      pozicijaodvodakondenzata3: 0
    };
    // OKOLNI
    if (dvodelni_front_i_back === false) {
      // JEDNODELNI FRONT I BACK
      profili_postolja_arr.push({
        tempkey: 310,
        tip: 'FRONT',
        duzina: duzina_za_front_i_back,
        kolicina: 1,
        smerojacanjapostolja,
        ..._odvod123
      });
      profili_postolja_arr.push({
        tempkey: 320,
        tip: 'BACK',
        duzina: duzina_za_front_i_back,
        kolicina: 1,
        smerojacanjapostolja,
      });
    } else {
      // PODELJENI FRONT I BACK
      profili_postolja_arr.push({
        tempkey: 311,
        tip: 'FRONT_1',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
        ..._odvod123
      });
      profili_postolja_arr.push({
        tempkey: 312,
        tip: 'FRONT_2',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
        ..._odvod123
      });
      profili_postolja_arr.push({
        tempkey: 321,
        tip: 'BACK_1',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 322,
        tip: 'BACK_2',
        duzina: duzina_za_front_i_back / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
    }
    if (dvodelni_laft_i_right === false) {
      // JEDNODELNI LEFT I RIGHT
      profili_postolja_arr.push({
        tempkey: 410,
        tip: 'LEFT',
        duzina: duzina_za_left_i_right,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 420,
        tip: 'RIGHT',
        duzina: duzina_za_left_i_right,
        kolicina: 1,
        smerojacanjapostolja,
      });
    } else {
      // PODELJENI LEFT I RIGHT
      profili_postolja_arr.push({
        tempkey: 411,
        tip: 'LEFT_1',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 412,
        tip: 'LEFT_2',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 421,
        tip: 'RIGHT_1',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
      profili_postolja_arr.push({
        tempkey: 422,
        tip: 'RIGHT_2',
        duzina: duzina_za_left_i_right / 2,
        kolicina: 1,
        smerojacanjapostolja,
      });
    }

    // OJACANJA za sirinski se unose rucno
  }
  //
  return {
    // sirinapostolja,
    // duzinapostolja,
    // profili_postolja_arr
    _arr: profili_postolja_arr
  };
};


export const _derivat_postolje_pozicijaodvodakondenzata123_final = (smerojacanjapostolja, tip, poz1, poz2, poz3, duzina_front_1) => {
  if (smerojacanjapostolja === 'POSIRINI') {
    // - Samo kad je postolje sa smerojacanja POSIRINI moze da ima kadicu i tada moze da ima rupe za odvod kondenzacije.
    const poz_arr = [
      poz1,
      poz2,
      poz3
    ];
    const duzina_prve_polovine = duzina_front_1;
    const _tip = tip;
    const _fix = (poz) => {
      if (poz >= 0) {
        return poz;
      }
      return 0; // return zero if undefined
    };
    if (_tip === 'FRONT') {
      const pozicije_final = {
        pozicijaodvodakondenzata1: _fix(poz_arr[0]),
        pozicijaodvodakondenzata2: _fix(poz_arr[1]),
        pozicijaodvodakondenzata3: _fix(poz_arr[2]),
      };
      console.log('FRONT pozicije_final', pozicije_final);
      return pozicije_final;
    } else if (_tip === 'FRONT_1' || _tip === 'FRONT_2') {
      const poz_arr_1 = [];
      const poz_arr_2 = [];
      poz_arr.forEach((poz) => {
        if (poz > 0) {
          if (duzina_front_1 > 0 && poz <= duzina_prve_polovine) {
            poz_arr_1.push(poz);
          } else {
            poz_arr_2.push(poz);
          }
        }
      });
      if (_tip === 'FRONT_1') {
        const pozicije_final = {
          pozicijaodvodakondenzata1: poz_arr_1[0] > 0 ? (poz_arr_1[0]) : (0),
          pozicijaodvodakondenzata2: poz_arr_1[1] > 0 ? (poz_arr_1[1]) : (0),
          pozicijaodvodakondenzata3: poz_arr_1[2] > 0 ? (poz_arr_1[2]) : (0)
        };
        console.log(pozicije_final);
        return pozicije_final;
      } else if (_tip === 'FRONT_2') {
        const pozicije_final = {
          pozicijaodvodakondenzata1: poz_arr_2[0] > 0 ? (poz_arr_2[0] - duzina_prve_polovine) : (0),
          pozicijaodvodakondenzata2: poz_arr_2[1] > 0 ? (poz_arr_2[1] - duzina_prve_polovine) : (0),
          pozicijaodvodakondenzata3: poz_arr_2[2] > 0 ? (poz_arr_2[2] - duzina_prve_polovine) : (0)
        };
        console.log(pozicije_final);
        return pozicije_final;
      }
    }
  }
  return {}; // ako postolje nije POSIRINI onda nema ovih propertija i pri unbudnleovanju bundleDraftela ove tri pozicije ce ostati null.
};


export const _derivat_postolje_pozicijaojacanja1234_final = (smerojacanjapostolja, tip, sirinaprofilapostolja, poz1, poz2, poz3, poz4, dimenzijazapozicije, duzina_front_1, duzina_left_1) => {
  console.log('smerojacanjapostolja, tip, sirinaprofilapostolja, poz1, poz2, poz3, poz4, dimenzijazapozicije, duzina_front_1, duzina_left_1');
  console.log(smerojacanjapostolja, tip, sirinaprofilapostolja, poz1, poz2, poz3, poz4, dimenzijazapozicije, duzina_front_1, duzina_left_1);
  // izracunavanje pozicija1,2,3 i 4 za profilpostolje u sastavnici koji nosi ove otvore
  const poz1negativ = poz1 > 0 ? (dimenzijazapozicije - poz1) : (0);
  const poz2negativ = poz2 > 0 ? (dimenzijazapozicije - poz2) : (0);
  const poz3negativ = poz3 > 0 ? (dimenzijazapozicije - poz3) : (0);
  const poz4negativ = poz4 > 0 ? (dimenzijazapozicije - poz4) : (0);
  let oduzmi_s_leva = 0;
  let duzina_prve_polovine = 0;
  let duzina_druge_polovine = 0;
  let _tip = '';
  if (smerojacanjapostolja === 'PODUZINI') {
    duzina_prve_polovine = duzina_left_1;
    oduzmi_s_leva = sirinaprofilapostolja; // kada je PODUZNI onda je LEFT nosac pozicija...
    if (tip === 'LEFT') {
      _tip = 'FRONT';
    }
    if (tip === 'LEFT_1') {
      _tip = 'FRONT_1';
    }
    if (tip === 'LEFT_2') {
      _tip = 'FRONT_2';
    }
    if (tip === 'RIGHT') {
      _tip = 'BACK';
    }
    if (tip === 'RIGHT_1') {
      _tip = 'BACK_1';
    }
    if (tip === 'RIGHT_2') {
      _tip = 'BACK_2';
    }
  } else if (smerojacanjapostolja === 'POSIRINI') {
    duzina_prve_polovine = duzina_front_1;
    oduzmi_s_leva = 0; // kada je POSIRINI onda je FRONT nosac pozicija i on pocinje od levog coska
    _tip = tip;
  }
  duzina_druge_polovine = dimenzijazapozicije - duzina_prve_polovine;
  console.log('duzina_prve_polovine', duzina_prve_polovine, 'duzina_druge_polovine', duzina_druge_polovine);
  const _fix = (poz) => {
    if (poz >= 0) {
      return poz;
    }
    return 0; // return zero if undefined
  };
  //
  if (_tip === 'FRONT' || _tip === 'FRONT_1' || _tip === 'FRONT_2') {
    const poz_arr = [
      _fix(poz1 - oduzmi_s_leva),
      _fix(poz2 - oduzmi_s_leva),
      _fix(poz3 - oduzmi_s_leva),
      _fix(poz4 - oduzmi_s_leva)
    ];
    if (_tip === 'FRONT') {
      const pozicije_final = {
        pozicijaojacanja1: poz_arr[0],
        pozicijaojacanja2: poz_arr[1],
        pozicijaojacanja3: poz_arr[2],
        pozicijaojacanja4: poz_arr[3]
      };
      console.log(pozicije_final);
      return pozicije_final;
    }
    if (_tip === 'FRONT_1' || _tip === 'FRONT_2') {
      const poz_arr_1 = [];
      const poz_arr_2 = [];
      poz_arr.forEach((poz) => {
        if (poz > 0) {
          if (poz <= duzina_prve_polovine) {
            poz_arr_1.push(poz);
          } else {
            poz_arr_2.push(poz);
          }
        }
      });
      if (_tip === 'FRONT_1') {
        const pozicije_final = {
          pozicijaojacanja1: poz_arr_1[0] > 0 ? (poz_arr_1[0]) : (0),
          pozicijaojacanja2: poz_arr_1[1] > 0 ? (poz_arr_1[1]) : (0),
          pozicijaojacanja3: poz_arr_1[2] > 0 ? (poz_arr_1[2]) : (0),
          pozicijaojacanja4: poz_arr_1[3] > 0 ? (poz_arr_1[3]) : (0),
        };
        console.log(pozicije_final);
        return pozicije_final;
      } else if (_tip === 'FRONT_2') {
        const pozicije_final = {
          pozicijaojacanja1: poz_arr_2[0] > 0 ? (poz_arr_2[0] - duzina_prve_polovine) : (0),
          pozicijaojacanja2: poz_arr_2[1] > 0 ? (poz_arr_2[1] - duzina_prve_polovine) : (0),
          pozicijaojacanja3: poz_arr_2[2] > 0 ? (poz_arr_2[2] - duzina_prve_polovine) : (0),
          pozicijaojacanja4: poz_arr_2[3] > 0 ? (poz_arr_2[3] - duzina_prve_polovine) : (0),
        };
        console.log(pozicije_final);
        return pozicije_final;
      }
    }
  }
  if (_tip === 'BACK' || _tip === 'BACK_1' || _tip === 'BACK_2') {
    const _poz_arr = [
      _fix(poz1negativ > 0 ? (poz1negativ - oduzmi_s_leva) : (0)),
      _fix(poz2negativ > 0 ? (poz2negativ - oduzmi_s_leva) : (0)),
      _fix(poz3negativ > 0 ? (poz3negativ - oduzmi_s_leva) : (0)),
      _fix(poz4negativ > 0 ? (poz4negativ - oduzmi_s_leva) : (0))
    ]; // negativ pozicije
    console.log('+++++ TEST BACK _poz_arr', _poz_arr);
    const poz_arr = _poz_arr.sort((a, b) => { return a - b; }).filter((poz) => poz > 0);
    if (_tip === 'BACK') {
      const pozicije_final = {
        pozicijaojacanja1: _fix(poz_arr[0]),
        pozicijaojacanja2: _fix(poz_arr[1]),
        pozicijaojacanja3: _fix(poz_arr[2]),
        pozicijaojacanja4: _fix(poz_arr[3])
      };
      console.log(pozicije_final);
      return pozicije_final;
    }
    if (_tip === 'BACK_1' || _tip === 'BACK_2') {
      const poz_arr_1 = [];
      const poz_arr_2 = [];
      poz_arr.forEach((poz) => {
        if (poz > 0) {
          /*
          ODLUKA 2022-12-29 DL: Za sada se profili dele tacno na dve polovine (identicne duzine). A kada se ne dele po centru onda treba da budu simetrični tako da FRONT_1 ima identicnu duzinu kao BACK_2 i FRONT_2 identicnu duzinu kao BACK_1.
          */
          if (poz <= duzina_druge_polovine) { // ovo obezbedjuje simetriju FRONT_1 sa BACK_2 i FRONT_2 sa BACK_1 
            poz_arr_1.push(poz);
          } else {
            poz_arr_2.push(poz);
          }
        }
      });
      if (_tip === 'BACK_1') {
        const pozicije_final = {
          pozicijaojacanja1: poz_arr_1[0] > 0 ? (poz_arr_1[0]) : (0),
          pozicijaojacanja2: poz_arr_1[1] > 0 ? (poz_arr_1[1]) : (0),
          pozicijaojacanja3: poz_arr_1[2] > 0 ? (poz_arr_1[2]) : (0),
          pozicijaojacanja4: poz_arr_1[3] > 0 ? (poz_arr_1[3]) : (0),
        };
        console.log(pozicije_final);
        return pozicije_final;
      } else if (_tip === 'BACK_2') {
        const pozicije_final = {
          pozicijaojacanja1: poz_arr_2[0] > 0 ? (poz_arr_2[0] - duzina_prve_polovine) : (0),
          pozicijaojacanja2: poz_arr_2[1] > 0 ? (poz_arr_2[1] - duzina_prve_polovine) : (0),
          pozicijaojacanja3: poz_arr_2[2] > 0 ? (poz_arr_2[2] - duzina_prve_polovine) : (0),
          pozicijaojacanja4: poz_arr_2[3] > 0 ? (poz_arr_2[3] - duzina_prve_polovine) : (0),
        };
        console.log(pozicije_final);
        return pozicije_final;
      }
    }
  }
  return {}; // prazne pozicije za sastavnicu
};


export const derivatPoluproizvod_postolje_naziv = (duzina, sirina, visina, tip) => {
  // TODO
  // DL 2023-11-08: Naziv da bude POSTOLJE SIRNAxDUZINAxVISINA bez tipa.
  let naziv = "POSTOLJE " + SPACE + sirina + "x" + duzina + "x" + visina + "mm";
  return naziv;
};


export const derivatPoluproizvod_postoljeprofil_naziv = (tip, duzina) => {
  let _tip = '';
  if (tip === 'FRONT') {
    _tip = 'NAPRED';
  } else if (tip === 'FRONT_1') {
    _tip = 'NAPRED 1/2';
  } else if (tip === 'FRONT_2') {
    _tip = 'NAPRED 2/2';
  } else if (tip === 'BACK') {
    _tip = 'POZADI';
  } else if (tip === 'BACK_1') {
    _tip = 'POZADI 1/1';
  } else if (tip === 'BACK_2') {
    _tip = 'POZADI 1/2';
  } else if (tip === 'LEFT') {
    _tip = 'LEVI';
  } else if (tip === 'LEFT_1') {
    _tip = 'LEVI 1/2';
  } else if (tip === 'LEFT_2') {
    _tip = 'LEVI 2/2';
  } else if (tip === 'RIGHT') {
    _tip = 'DESNI';
  } else if (tip === 'RIGHT_1') {
    _tip = 'DESNI 1/2';
  } else if (tip === 'RIGHT_2') {
    _tip = 'DESNI 2/2';
  } else if (tip === 'REINFORCEMENT') {
    _tip = 'OJACANJE';
  } else if (tip === 'REINFORCEMENT_1') {
    _tip = 'OJACANJE 1/2';
  } else if (tip === 'REINFORCEMENT_2') {
    _tip = 'OJACANJE 2/2';
  }
  let naziv = "PROFIL POSTOLJA" + SPACE + _tip + SPACE + + duzina + SPACE + "mm";
  return naziv;
};


export const derivatPoluproizvod_postoljeprofil_cncprogram = (tip) => {
  let cnc_program = null;
  if (tip === 'FRONT') {
    cnc_program = 'Lim AHU Front-Back Postolje.S4';
  } else if (tip === 'FRONT_1') {
    cnc_program = 'Lim AHU Front-Back Postolje 1.S4';
  } else if (tip === 'FRONT_2') {
    cnc_program = 'Lim AHU Front-Back Postolje 2.S4';
  } else if (tip === 'BACK') {
    cnc_program = 'Lim AHU Front-Back Postolje.S4';
  } else if (tip === 'BACK_1') {
    cnc_program = 'Lim AHU Front-Back Postolje 1.S4';
  } else if (tip === 'BACK_2') {
    cnc_program = 'Lim AHU Front-Back Postolje 2.S4';
  } else if (tip === 'LEFT') {
    cnc_program = 'Lim AHU Left-Right Postolje.S4';
  } else if (tip === 'LEFT_1') {
    cnc_program = 'Lim AHU Left-Right Postolje 1.S4';
  } else if (tip === 'LEFT_2') {
    cnc_program = 'Lim AHU Left-Right Postolje 2.S4';
  } else if (tip === 'RIGHT') {
    cnc_program = 'Lim AHU Left-Right Postolje.S4';
  } else if (tip === 'RIGHT_1') {
    cnc_program = 'Lim AHU Left-Right Postolje 1.S4';
  } else if (tip === 'RIGHT_2') {
    cnc_program = 'Lim AHU Left-Right Postolje 2.S4';
  } else if (tip === 'REINFORCEMENT') {
    cnc_program = 'Lim AHU Left-Right Postolje.S4';
  } else if (tip === 'REINFORCEMENT_1') {
    cnc_program = 'Lim AHU Left-Right Postolje 1.S4';
  } else if (tip === 'REINFORCEMENT_2') {
    cnc_program = 'Lim AHU Left-Right Postolje 2.S4';
  }
  return cnc_program;
};


export const derivatPoluproizvod_postoljeprofil_izrcunaj_kolicinu_materijala = (tip, duzina, visina) => {
  let kolicina = 0;
  if (tip === 'FRONT' || tip === 'FRONT_1' || tip === 'FRONT_2' || tip === 'BACK' || tip === 'BACK_1' || tip === 'BACK_2') {
    /*
    Type 1
    Formula for Profile Front, Back (they have free ends, they are not fixed to another profile) is:
  
    Profile Length * (Height +123.2mm)
    */
    kolicina = (duzina * (visina + 123.2)) / (1000000);
  } else {
    /*
    Type 2
    Formula for Profile Left, Right or Width Reinforcement (they do not have free ends, they are fixed to another profile) is:
    
    (Profile Length+87.6mm) * (Height +123.2mm)
    */
    kolicina = ((duzina + 87.6) * (visina + 123.2)) / (1000000);
  }
  return kolicina;
};


/*
export const derivatPoluproizvod_postolje_dopuni = (p) => {
  // SPECIJALNI KORAK
  // Poluproizvodu dodajemo neke podatke koji su mu potrebni!
 
  let postolje = {
    ...p,
    ..._getParamsFromLib("terkk$postolje"),
    naziv: derivatPoluproizvod_postolje_naziv(p.tip, p.duzina, p.sirina, p.odvodkondenzata)
  };
  return postolje;
};
*/


export const derivat_postoljeprofil_pripremi_pods_input_inherited_za_draftel = (virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_postolje.default_pods_input_state(),
    vrstaprofila: virtel_m.vrstaprofila,
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    duzinamodula: virtel_m.duzinamodula
  };
  return pods_input_inherited;
};


export const derivatAutoCreateVirtel_postoljeprofil_priprema_ulaza = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input = {
    p: p,
    tip: p.tip,
    sirinapostolja: p.sirinapostolja,
    visinapostolja: p.visinapostolja,
    // duzinapostolja: p.duzinapostolja,
    duzina: p.duzina,
    cncprogram1: p.cncprogram1,
  };
  return pods_input;
};


// profili poostolja
export const derivatAutoCreateVirtel_postoljeprofil_children = (pods_input) => {
  // console.log('derivatAutoCreateVirtel_postolje(pods_input) ');
  console.log(pods_input);
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // pods_input, promenljive iz excela
  const tip = pods_input.tip;
  const visinapostolja = pods_input.visinapostolja;
  const duzina = pods_input.duzina;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterProfiliPostolja = 0;
  /*
  console.log(typeof _arr_postoljeprofil);
  console.log(Array.isArray(_arr_postoljeprofil));
  console.log(_arr_postoljeprofil);
  // forEach je koriscen u slucaju kad smo imali poluproitvod postolje i onda mu dodavali postolje profile kao childrene. Sad smo to iskljucili jer profili postolja direktno ulaze u sastav modula
  _arr_postoljeprofil.forEach((profil) => {
    // EACH
    _counterProfiliPostolja++;
    */

  if (visinapostolja > 100) {
    // CASE VISOKI - slucaj kada je visinapostolja veca od 100mm.


    /*
    let profilkey = 'derivatpostoljeprofil' + _counterProfiliPostolja;
 
    // derivat EACH local 1
    _derivat_key = profilkey;
    x = {
      _derivat_key,
      ..._getParamsFromLib("terkk$profilpregradni_op_obrada"),
      kolicina: profil.kolicina,
      duzina: profil.duzina,
      tip: profil.tip,
      terkategorija: 'PP',
      tergrupa: 'PROFIL_POSTOLJA',
      virtelschemakey: 'terkk$postolje$profil',
      // _draftelschemakey: 'terkk$modul$profilpregradni',
      // terkknivo: 'CHILDOFMODUL',
    };
    x.naziv = "Profil postolja " + x.tip + SPACE + x.duzina + "mm";
    x._materijal_naziv = x.naziv + '_m ???';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    */


    // derivat EACH local 1

    // S4+P4 operacija 1.
    const _pods_input = { ...pods_input.p }; // vecina propertija isto kao poslednja operacija
    delete _pods_input.subkey;
    delete _pods_input.parent_subkey;
    delete _pods_input.bundle_id;
    x = {
      // ...x,
      ..._pods_input, // vecina propertija isto kao poslednja operacija
      virtelclass: "terkk$postolje$profil_opsec",
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._getParamsFromLib("terkk$postolje$profil_opsec"),
    };
    // _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // _derivat_key = _derivat_key + '_m';
    _derivat_key = 'derivatpostoljeprofil' + '_m';
    // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    // _materijal_naziv = x._materijal_naziv;
    _materijal_naziv = "LIM POCINKOVANI 2.50";
    // const tip = p.tip;
    const _kolicina = derivatPoluproizvod_postoljeprofil_izrcunaj_kolicinu_materijala(tip, duzina, visinapostolja); // TODO
    xm = {
      naziv: _materijal_naziv,
      calculated_ident: 'LB00000L',
      terkategorija: 'M',
      kolicina: _kolicina, // ???
      jm: tclocal.JM_M2,
      //
      _derivat_key,
      virtelschemakey: 'terkk$postolje$profil$materijal1',
      virtelclass: 'terkk$_grupa_lim.1_materijal',
    };
    z[_derivat_key] = xm;
    // _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
    // _virbom_manipulator.add_on_top_graphlevel(virbom_ref, xm);
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);

  } else {
    // CASE NISKI- Slucaj kada je visinapostolja 100mm ili manje.


    // derivat EACH local 1
    // S4+P4 operacija 2.  S4+P4+ERMAKSAN
    _derivat_key = 'derivatpostoljeprofil_niski.1';
    const _pods_input = { ...pods_input.p }; // vecina propertija isto kao poslednja operacija
    delete _pods_input.subkey;
    delete _pods_input.parent_subkey;
    delete _pods_input.bundle_id;
    x = {
      _derivat_key,
      ..._pods_input, // vecina propertija isto kao poslednja operacija
      virtelschemakey: 'terkk$postolje$profil',
      multitranslator_lang: "terkk$postolje/postolje_profil",
    };
    x = {
      ...x,
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE // pošto ovo nije prva operacija onda je količina 1.
      // ..._getParamsFromLib("terkk$postolje$profil_niski.1"),
      virtelclass: "terkk$postolje$profil_niski_opsav",
      ..._getParamsFromLib("terkk$postolje$profil_niski_opsav"),
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // S4+P4 operacija 1. S4+P4+ERMAKSAN
    x = {
      ...x,
      virtelclass: "terkk$postolje$profil_niski_opsec",
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._getParamsFromLib("terkk$postolje$profil_niski_opsec"),
    };
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);


    // derivat EACH local 1.1
    // _derivat_key = _derivat_key + '_m';
    _derivat_key = 'derivatpostoljeprofil' + '_m';
    // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    // _materijal_naziv = x._materijal_naziv;
    _materijal_naziv = "LIM POCINKOVANI 2.50";
    // const tip = p.tip;
    const _kolicina = derivatPoluproizvod_postoljeprofil_izrcunaj_kolicinu_materijala(tip, duzina, visinapostolja); // TODO
    xm = {
      naziv: _materijal_naziv,
      calculated_ident: 'LB00000L',
      terkategorija: 'M',
      kolicina: _kolicina, // ???
      jm: tclocal.JM_M2,
      //
      _derivat_key,
      virtelschemakey: 'terkk$postolje$profil$materijal1',
      virtelclass: 'terkk$_grupa_lim.1_materijal'
    };
    z[_derivat_key] = xm;
    // _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);

  }



  // });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


/*
export const derivatAutoCreateVirtel_gotovoproba1 = (pods_input, _arr_postoljeprofil) => {
  // console.log('derivatAutoCreateVirtel_postolje(pods_input) ');
  console.log(pods_input);
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterProfiliPostolja = 0;
  console.log(typeof _arr_postoljeprofil);
  console.log(Array.isArray(_arr_postoljeprofil));
  console.log(_arr_postoljeprofil);
  _arr_postoljeprofil.forEach((profil) => {
    // EACH
    _counterProfiliPostolja++;
    let profilkey = 'profilpostolja' + _counterProfiliPostolja;


    // derivat EACH local 1
    _derivat_key = profilkey;
    x = {
      _derivat_key,
      ..._getParamsFromLib("terkk$profilpregradni_op_obrada"),
      kolicina: profil.kolicina,
      duzina: profil.duzina,
      tip: profil.tip,
      terkategorija: 'PP',
      tergrupa: 'PROFIL_POSTOLJA',
      virtelschemakey: 'terkk$postolje$profil',
      // _draftelschemakey: 'terkk$modul$profilpregradni',
      // terkknivo: 'CHILDOFMODUL',
    };
    x.naziv = "Profil postolja " + x.tip + SPACE + x.duzina + "mm";
    x._materijal_naziv = x.naziv + '_m ???';
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // derivat EACH local 1.1
    _derivat_key = _derivat_key + '_m';
    // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    const _materijal_naziv = x._materijal_naziv;
    // const tip = p.tip;
    const _kolicina = 999; // TODO
    xm = {
      naziv: _materijal_naziv,
      calculated_ident: '???',
      terkategorija: 'M',
      kolicina: _kolicina, // ???
      jm: tclocal.JM_M2,
      //
      _derivat_key,
      virtelschemakey: 'terkk$postolje$profil$materijal1'
    };
    z[profilkey + '_m'] = xm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  });  // end of PETLJA----------
  //


  console.log(z);

  
  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};
*/

